import { ReactNode } from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

interface FormPanelProps {
  title?: string;
  children: ReactNode;
  /** Двухколоночная сетка полей на десктопе (как в макете) */
  columns?: 1 | 2;
  className?: string;
}

/** Светло-синяя панель с рамкой, в которую макет группирует поля шага. */
const FormPanel = ({ title, children, columns = 2, className }: FormPanelProps) => (
  <div className={cn(styles.panel, className)}>
    {title && <h4 className={styles.title}>{title}</h4>}
    <div className={cn(styles.fields, { [styles.fieldsSingle]: columns === 1 })}>{children}</div>
  </div>
);

export default FormPanel;
